module.exports = __webpack_public_path__ + "static/media/TZ.7ca11fdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TZ.svg
// module id = 381
// module chunks = 0